<div class="mt-2">
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <!-- Users -->
    <li ngbNavItem>
      <button ngbNavLink>Users</button>
      <ng-template ngbNavContent style="position: relative; width: 100%">
        @if (combinedGridReady) {
          <div>
            <div class="summary">
              Users: {{ getFilteredCount(combinedGridApi) }} / {{ combinedUsers.length }}, Size:
              {{ getFilteredTotalSize(combinedGridApi) | bytes: 0 }}

              <!-- clear filters button -->
              <button
                [disabled]="!combinedGridApi.isAnyFilterPresent()"
                class="btn btn-sm btn-info"
                (click)="onClearFilters(combinedGridApi)">
                Clear filters
              </button>

              <!-- old guests button -->
              <button class="btn btn-sm btn-secondary" (click)="onSelectOldGuests(combinedGridApi)">
                Filter old guests
              </button>

              <!-- list filter buttons -->
              <button class="btn btn-sm btn-secondary ms-4" (click)="onToggleListFilter()">
                @if (listFilterVisible) {
                  <span>Close</span>
                } @else {
                  <span>Open</span>
                }
                filter list
              </button>
              <button class="btn btn-sm btn-secondary" (click)="onFilterListed(combinedGridApi)">
                Filter listed users
              </button>

              <!-- delete button -->
              <div ngbDropdown class="delete">
                <button
                  type="button"
                  [disabled]="combinedUsers.length < 1"
                  class="btn btn-sm btn-danger"
                  id="dropdownBasic1"
                  ngbDropdownToggle>
                  Delete
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="onDeleteUsers(getFilteredRows(combinedGridApi))">
                    Delete users
                  </button>
                  <button ngbDropdownItem (click)="onDeleteSessions(getFilteredRows(combinedGridApi))">
                    Delete sessions
                  </button>
                  <button ngbDropdownItem (click)="onDeleteUsersAndSessions(getFilteredRows(combinedGridApi))">
                    Delete users and sessions
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- user list filter -->
        <textarea
          [hidden]="!listFilterVisible"
          class="mb-1 form-control"
          #notesArea
          id="session-notes"
          rows="15"
          placeholder="One user per line. If line contains a comma, only use the first part."
          [(ngModel)]="listFilterText"></textarea>

        @if (allSessionsState.isReady()) {
          <ag-grid-angular style="width: 100%; height: 700px" [gridOptions]="combinedGridOptions"></ag-grid-angular>
        } @else {
          <ch-status [state]="allSessionsState"></ch-status>
        }

        @if (combinedGridReady) {
          <div class="text-monospace text-small m-3">
            @for (user of getFilteredRows(combinedGridApi); track user) {
              <div>{{ user.username }}</div>
            }
          </div>
        }
      </ng-template>
    </li>

    <!-- Auth only -->
    <li ngbNavItem>
      <button ngbNavLink>Auth only</button>
      <ng-template ngbNavContent>
        @if (authOnlyGridReady) {
          <div>
            <div class="summary">
              Users: {{ getFilteredCount(authOnlyGridApi) }} / {{ authOnlyUsers.length }}

              <!-- clear filters button -->
              <button
                [disabled]="!authOnlyGridApi.isAnyFilterPresent()"
                class="btn btn-sm btn-info"
                (click)="onClearFilters(authOnlyGridApi)">
                Clear filters
              </button>

              <!-- old guests button -->
              <button class="btn btn-sm btn-secondary" (click)="onSelectOldGuests(authOnlyGridApi)">
                Filter old guests
              </button>

              <!-- list filter buttons -->
              <button class="btn btn-sm btn-secondary ms-4" (click)="onToggleListFilter()">
                @if (listFilterVisible) {
                  <span>Close</span>
                } @else {
                  <span>Open</span>
                }
                filter list
              </button>
              <button class="btn btn-sm btn-secondary" (click)="onFilterListed(authOnlyGridApi)">
                Filter listed users
              </button>

              <!-- delete button -->
              <div class="delete">
                <button
                  [disabled]="authOnlyUsers.length < 1"
                  class="btn btn-sm btn-danger"
                  (click)="onDeleteUsers(getFilteredRows(authOnlyGridApi))">
                  Delete users
                </button>
              </div>
            </div>
          </div>
        }

        <!-- user list filter -->
        <textarea
          [hidden]="!listFilterVisible"
          class="mb-1 form-control"
          #notesArea
          id="session-notes"
          rows="15"
          placeholder="One userId per line. If the line contains a comma, only the first part will be used."
          [(ngModel)]="listFilterText"></textarea>

        @if (allSessionsState.isReady()) {
          <ag-grid-angular style="width: 100%; height: 700px" [gridOptions]="authOnlyGridOptions"></ag-grid-angular>
        } @else {
          <ch-status [state]="allSessionsState"></ch-status>
        }

        @if (authOnlyGridReady) {
          <div class="text-monospace text-small m-3">
            @for (user of getFilteredRows(authOnlyGridApi); track user) {
              <div>{{ user.username }}</div>
            }
          </div>
        }
      </ng-template>
    </li>

    <!-- SessionDB only -->
    <li ngbNavItem>
      <button ngbNavLink>SessionDB only</button>
      <ng-template ngbNavContent>
        @if (sessionDbOnlyGridReady) {
          <div>
            <div class="summary">
              Users: {{ getFilteredCount(sessionDbOnlyGridApi) }} / {{ sessionDbOnlyUsers.length }}

              <!-- clear filters button -->
              <button
                [disabled]="!sessionDbOnlyGridApi.isAnyFilterPresent()"
                class="btn btn-sm btn-info"
                (click)="onClearFilters(sessionDbOnlyGridApi)">
                Clear filters
              </button>

              <!-- list filter buttons -->
              <button class="btn btn-sm btn-secondary ms-4" (click)="onToggleListFilter()">
                @if (listFilterVisible) {
                  <span>Close</span>
                } @else {
                  <span>Open</span>
                }
                filter list
              </button>
              <button class="btn btn-sm btn-secondary" (click)="onFilterListed(sessionDbOnlyGridApi)">
                Filter listed users
              </button>

              <!-- delete button -->
              <div class="delete">
                <button
                  [disabled]="sessionDbOnlyUsers.length < 1"
                  class="btn btn-sm btn-danger"
                  (click)="onDeleteSessions(getFilteredRows(sessionDbOnlyGridApi))">
                  Delete sessions
                </button>
              </div>
            </div>
          </div>
        }

        <!-- user list filter -->
        <textarea
          [hidden]="!listFilterVisible"
          class="mb-1 form-control"
          #notesArea
          id="session-notes"
          rows="15"
          placeholder="One user per line. If line contains a comma, only use the first part."
          [(ngModel)]="listFilterText"></textarea>

        @if (allSessionsState.isReady()) {
          <ag-grid-angular
            style="width: 100%; height: 700px"
            [gridOptions]="sessionDbOnlyGridOptions"></ag-grid-angular>
        } @else {
          <ch-status [state]="allSessionsState"></ch-status>
        }

        @if (sessionDbOnlyGridReady) {
          <div class="text-monospace text-small m-3">
            @for (user of getFilteredRows(sessionDbOnlyGridApi); track user) {
              <div>{{ getUsername(user.userId) }}</div>
            }
          </div>
        }
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>

  <ng-template #modalContent let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="tableTitle">Sessions of {{ selectedUser }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>

    <div class="modal-body scrollable-parent">
      @if (!userSessionsState.isReady()) {
        <div>Loading sessions...</div>
      }
      @if (userSessionsState.isReady()) {
        <div class="scrollable">
          <!-- checkbox for enabling session name column in the table -->
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="showSessionNames" [(ngModel)]="showSessionNames" />
            <label class="form-check-label" for="showSessionNames">Show session names</label>
          </div>

          <!-- sessions table -->
          <table class="table table-sm table-striped" aria-describedby="tableTitle">
            <thead>
              <tr>
                @if (showSessionNames) {
                  <th scope="col">Name</th>
                }
                <th scope="col">SessionId</th>
                <th scope="col">Size</th>
                <th scope="col">Datasets</th>
                <th scope="col">Jobs</th>
                <th scope="col">Inputs</th>
                <th scope="col">Parameters</th>
                <th scope="col">Phenodata entries</th>
              </tr>
            </thead>
            <tbody>
              @for (session of sessions; track session.sessionId) {
                <tr>
                  @if (showSessionNames) {
                    <td>{{ session.name }}</td>
                  }
                  <td>{{ session.sessionId }}</td>
                  <td>{{ session.size | bytes: 0 }}</td>
                  <td>{{ session.datasetCount }}</td>
                  <td>{{ session.jobCount }}</td>
                  <td>{{ session.inputCount }}</td>
                  <td>{{ session.parameterCount }}</td>
                  <td>{{ session.metadataCount }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </ng-template>
</div>
